import CRUDFactory, { API_URL } from './crud_factory';

type DeleteBillToLocationResponse = { success: boolean; message: string; };
interface BillToLocationFactoryType extends CRUDFactory {
  delete(id: number): Promise<DeleteBillToLocationResponse>;
};
export default new CRUDFactory({
  baseUrl: `${API_URL}bill_to_locations/`,
}) as BillToLocationFactoryType;